export const urls = window.env?.urls;
export const profileBuilderConfig = window.env?.profileBuilderConfig;
